<template>
  <svg xmlns="http://www.w3.org/2000/svg" height="18px" viewBox="0 -960 960 960" width="18px" fill="none">
    <path
      d="M295.35-595.56v170q0 20.35-14.25 34.63-14.24 14.28-34.54 14.28-20.3 0-34.76-14.3-14.45-14.3-14.45-34.67v-287.75q0-20.37 14.29-34.83 14.3-14.45 34.68-14.45h287.74q20.37 0 34.83 14.24 14.46 14.25 14.46 34.55 0 20.29-14.28 34.75t-34.63 14.46h-170l387.6 387.61Q767-262.09 767-243t-14.96 34.04Q737.09-194 717.5-194t-34.54-14.96l-387.61-386.6Z"
      :fill="fill"
    />
  </svg>
</template>
<script>
export default {
  props: {
    fill: {
      type: String
    }
  }
}
</script>
